import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import DmcaForm from "@/components/compliance/DmcaForm";

const Dmca = () => (
  <div className="min-h-screen flex flex-col bg-background text-foreground">
    <SiteHeader />
    <main className="flex-1 mx-auto w-full max-w-2xl px-6 py-16">
      <p className="text-xs font-medium uppercase tracking-[0.24em] text-muted-foreground">
        DMCA
      </p>
      <h1 className="mt-3 text-4xl font-bold tracking-tight">Copyright takedown</h1>
      <p className="mt-4 text-muted-foreground">
        Wavlynq complies with the Digital Millennium Copyright Act. Submit a
        properly formatted notice and we'll act promptly.
      </p>
      <div className="mt-10 rounded-2xl border border-border bg-card p-6">
        <DmcaForm />
      </div>
    </main>
    <SiteFooter />
  </div>
);

export default Dmca;
